export function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 lg:py-12">
      <div className="text-center mb-12">
        <h1 className="text-3xl lg:text-4xl font-serif font-bold text-slate-900 tracking-tight mb-3">
          Terms of Use
        </h1>
        <p className="text-sm text-slate-400">Last updated July 1, 2026</p>
      </div>

      <div className="space-y-8 text-slate-700">
        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Agreement to these terms</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            By creating an EventsCarousel account or using the app, you agree to these Terms of Use and our{' '}
            <a href="/privacy" className="text-indigo-600 hover:underline">Privacy Policy</a>. If you do
            not agree, do not register for or use EventsCarousel.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Zero tolerance for objectionable content and abusive users</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            EventsCarousel has no tolerance for objectionable content or abusive behavior of any kind, including
            but not limited to hate speech, harassment, threats, defamatory content, or content that
            exploits or endangers anyone. This applies to comments, photos, audio, and any other content
            you post, even within a private family archive.
          </p>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600 mt-3">
            Content that violates this policy is automatically filtered where possible, and any user or
            piece of content flagged as objectionable is reviewed and, where warranted, removed within 24
            hours. Accounts responsible for repeated or severe violations will be suspended or permanently
            removed from the platform.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Reporting objectionable content</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            Any comment can be reported directly from the event it appears on. Reporting a comment removes
            it from view immediately and notifies us for review. Use this whenever you see content that
            violates this policy.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Blocking abusive users</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            You can block any user directly from one of their comments. Blocking someone immediately hides
            all of their comments from your view and notifies us of the block for review. You can manage
            and undo blocks at any time from Settings → Blocked Users.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Account termination</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            We may suspend or terminate any account that violates this policy. You may delete your own
            account at any time from Settings → Delete Account — this permanently removes your account and,
            if you own a family archive, all events, photos, audio, and comments in it.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Contact</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            Questions about these terms, or want to report something outside the app? Email us at{' '}
            <a href="mailto:support@eventscarousel.com" className="text-indigo-600 hover:underline">
              support@eventscarousel.com
            </a>.
          </p>
        </section>
      </div>
    </div>
  );
}
